// @ts-ignore
import React from "react";

import { css } from "@compiled/react";

import { wacToken } from "@/libraries/design/foundations/index.ts";

import { Head, HeadCell, HeadRow } from "../atoms";

export interface HeaderProps {
    titles: string[];
    stickyOffset?: number;
}

export const Header = (props: HeaderProps) => {
    const { titles, stickyOffset } = props;

    return (
        <Head stickyOffset={stickyOffset}>
            <HeadRow>
                {titles.map((heading, index) => (
                    <HeadCell key={index}>
                        <div css={headCellDivCss}>
                            <span css={headCellSpanCss}>{heading}</span>
                        </div>
                    </HeadCell>
                ))}
            </HeadRow>
        </Head>
    );
};

const headCellDivCss = css({
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    alignItems: "flex-start"
});

const headCellSpanCss = css({
    color: wacToken("color.primary.black"),
    fontWeight: "700"
});
